module.exports = __webpack_public_path__ + "img/skill_level_undefined_svg.ee1c08a8.svg";